import React from 'react';
import { motion } from 'framer-motion';
export function PainNarrative() {
  return <section className="py-20 bg-white" data-id="element-134">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="prose prose-lg md:prose-xl text-gray-700" data-id="element-136">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy text-center mb-10" data-id="element-137">
            ¿Te suena familiar?
          </h2>

          <div className="space-y-6 text-lg leading-relaxed" data-id="element-138">
            <p className="font-medium text-xl text-navy" data-id="element-139">
              Domingo, 8:00 de la noche. Sientes ese nudo en el estómago porque
              sabes que mañana empieza todo de nuevo.
            </p>

            <p data-id="element-140">
              Sabes que te espera la Línea 1 llena, el taco interminable en
              Vespucio, las reuniones que pudieron ser un mail y un jefe que
              parece olvidar que tienes una vida fuera de la oficina.
            </p>

            <p data-id="element-141">
              Has intentado desconectar el fin de semana, pero el cansancio es
              tan profundo que el lunes despiertas sintiéndote igual o peor.
            </p>

            <div className="bg-orange-50 border-l-4 border-orange p-6 mt-8 rounded-r-lg" data-id="element-142">
              <p className="font-semibold text-navy m-0" data-id="element-143">
                No es falta de voluntad. Es que tu sistema nervioso está
                operando en modo supervivencia.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}